import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  content: string;
  image: string;
  slug: string;
  date: string;
  alt: string;
};

export default function BlogCard({
  title,
  content: rawContent,
  image,
  slug,
  date,
  alt,
}: Props) {
  const navigate = useNavigate();

  const content = useMemo(() => {
    const elem = document.createElement('div')
    elem.innerHTML = rawContent

    return elem.textContent ?? ''
  }, [rawContent])

  return (
    <button
      onClick={() => navigate(`/blogs/${`${slug}`}?origin=list`)}
      className="h-full text-left"
    >
      <div
        className="
          flex h-full flex-col
          overflow-hidden rounded-xl
          border bg-white shadow-sm
          transition hover:-translate-y-1 hover:shadow-md
        "
      >
        {/* Image */}
       <div className="flex flex-col md:flex-row gap-6 p-6">
  <div className="md:w-64 h-40 overflow-hidden rounded-lg shrink-0">
   <img
  src={`${image}-800.jpg`}
  srcSet={`${image}-480.jpg 480w, ${image}-800.jpg 800w`}
  sizes="(max-width: 768px) 100vw, 33vw"
  alt={alt}
  loading="lazy"
  decoding="async"
  className="w-full h-full object-cover"
/>
  </div>

  <div className="flex flex-col justify-between">
    <div>
      <p className="text-xs text-gray-500">{date}</p>
      <h3 className="mt-2 text-xl font-semibold text-gray-900">
        {title}
      </h3>
      <p className="mt-3 text-gray-600 line-clamp-3">
        {content}
      </p>
    </div>
  </div>
</div>

      </div>
    </button>
  );
}
